/* eslint-disable react/jsx-props-no-spreading */
// @ts-nocheck
import React, { FC, useEffect } from 'react';
import cn from 'classnames';
import { useFormState, TextArea, useFieldApi } from 'informed';
import css from './styles.module.scss';

export interface ITextAreaField {
  name: string;
  placeholder?: string;
  className?: string;
  defaultValue?: string;
  label?: string;
  validate?: (value: unknown) => void | string;
  onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const TextAreaField: FC<ITextAreaField> = ({
  name,
  className,
  defaultValue = '',
  label,
  ...rest
}) => {
  const formState = useFormState();
  const { errors } = formState;
  const error = errors?.[name];

  const { setValue } = useFieldApi(name);

  useEffect(() => {
    if (defaultValue) {
      setValue(defaultValue);
    }
  }, [defaultValue]);

  return (
    <>
      {label && (
        <label htmlFor={name} className={css.label}>
          {label}
        </label>
      )}
      <TextArea className={cn(css.field, className, { fieldError: error })} name={name} {...rest} />
      {error ? <p className={css.error}>{error as string}</p> : null}
    </>
  );
};

export default TextAreaField;
